export default __webpack_public_path__ + "static/media/photo--lg--gord.2aa1c562.jpg";